import styled from 'styled-components';

import { colors, fonts } from '../../../theme/styled';

export const Counter = styled.div`
  display: inline-block;
  margin: 0 0.5rem;

  font-family: ${fonts.titleFont};
`;

export const CounterLabel = styled.div`
  margin-bottom: 0.25rem;

  font-family: ${fonts.secondFont};
  font-style: italic;
  font-size: clamp(0.8125rem, 3vw, 1rem);

  letter-spacing: -0.025rem;

  color: ${colors.white};

  user-select: none;
`;

export const CounterDigitsContainer = styled.div`
  line-height: 0;
`;
